import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { handleSearchParams } from "@/api/handleSearchParams";
import { API_URL } from "@/constants/envVariables";
import { fetchApi } from "@/helpers/fetchApi";
import { ApiAuditLogs, AppError, AuditLogSearchParams } from "@/types";

export const useAuditLogs = (
  searchParams?: AuditLogSearchParams,
  options?: Omit<UseQueryOptions<ApiAuditLogs, AppError>, "queryKey" | "queryFn">,
) => {
  const params = handleSearchParams(searchParams);

  const query = useQuery<ApiAuditLogs, AppError>({
    queryKey: ["auditLogs", { ...searchParams }],
    queryFn: async () => {
      return await fetchApi(`${API_URL}/audit-logs/${params}`);
    },
    placeholderData: (prev) => prev,
    ...options,
  });

  return query;
};
